<pg-notification
  [elevation]="3"
  action="dismiss"
  type="flag"
  [color]="options?.color"
  [modifier]="options?.bold ? 'bold' : null"
  [display]="true"
  [preventDefaultDismissBehavior]="true"
  (dismissClick)="handleNotificationDismiss()"
>
  <pg-notification-title>{{ data?.title }}</pg-notification-title>
  <pg-notification-body *ngIf="data?.body">{{
    data.body
  }}</pg-notification-body>
  <pg-notification-action *ngIf="data?.action">
    <a (click)="handleActionClicked()">{{ data.action }}</a>
  </pg-notification-action>
</pg-notification>
